/*
 * Combined listings selector
 * ==========================
 * Two jobs, both progressive enhancement:
 *
 * 1. Keep the selected variant name in sync. Selecting a swatch on the product being viewed
 *    doesn't reload, and the theme's VariantSelects only re-renders the price containers, so the
 *    name above the grid has to be updated here.
 * 2. Prefetch cross-product links on hover/focus, to mask the reload.
 *
 * Selecting a variant needs none of this. Swatches belonging to the product being viewed are
 * radios inside the theme's existing <variant-radios> custom element, which handles them with no
 * help from here. If this file fails to load, the selector still works.
 */

(() => {
  const bindSelectedName = (root) => {
    (root || document).querySelectorAll('.cl-selector').forEach((selector) => {
      if (selector.dataset.clNameBound) return;

      const output = selector.querySelector('[data-cl-selected-name]');
      if (!output) return;

      selector.dataset.clNameBound = 'true';

      // The change event bubbles from the radio up to the selector, the same way
      // VariantSelects listens for it.
      selector.addEventListener('change', (event) => {
        const radio = event.target;
        if (!radio.classList || !radio.classList.contains('cl-swatch__input')) return;

        const title = radio.dataset.clVariantTitle;
        if (!title) return;

        output.textContent = `${output.dataset.clOptionName}: ${title}`;
      });
    });
  };

  const prefetch = (link) => {
    if (link.dataset.clPrefetched) return;
    link.dataset.clPrefetched = 'true';

    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = link.href;
    document.head.appendChild(hint);
  };

  const bindPrefetch = (root) => {
    // Prefetching in the theme editor would just add noise to a preview that reloads constantly.
    if (window.Shopify && window.Shopify.designMode) return;

    (root || document).querySelectorAll('a[data-cl-prefetch]').forEach((link) => {
      if (link.dataset.clPrefetchBound) return;
      link.dataset.clPrefetchBound = 'true';

      link.addEventListener('mouseenter', () => prefetch(link), { once: true });
      link.addEventListener('focus', () => prefetch(link), { once: true });
    });
  };

  const init = (root) => {
    bindSelectedName(root);
    bindPrefetch(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Section re-renders replace the markup, so anything new needs binding again.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
